/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import "./custom-headline.module.css";
import { SvgHandler } from "../../../../svg-handler/svg-handler";
import editIcon from "../../../../../../assets/icons/edit.svg";

const EditContent = ({ onClickHandler, data }) => (
  <div class="edit-wrapper">
    <span>{data}</span>
    <span onClick={() => onClickHandler()}>
      <SvgHandler xlinkHref={editIcon} width="18" height="18" viewBox="0 0 18 18" />
    </span>
  </div>
);

export const CustomHeadline = ({ headline, editData, onEdit = () => {}, id }) => {
  const arrayFromString = headline.split(/(\[email\]|\[phone-number\])/);
  const shortCodeIndex = arrayFromString.findIndex((item) => item === "[email]" || item === "[phone-number]");
  if (shortCodeIndex !== -1) {
    arrayFromString.splice(shortCodeIndex, 1, <EditContent onClickHandler={onEdit} data={editData} />);
  }

  return (
    <div styleName={editData ? "wrapper custom-style" : "wrapper"}>
      {arrayFromString.map((item) => (
        <>{item}</>
      ))}
    </div>
  );
};
